// General
import { ROLE_NAME } from './types/User';

export const APP_NAME = 'Scanning';
export const TABLET_MAX_WIDTH = 1366;

// Table
export const TABLE_DEFAULT_PAGE_SIZE = 10;
export const TABLE_DEFAULT_CURRENT_PAGE = 1;

export const ROLES = {
    ADMIN: 'admin_user',
    SITE_ADMIN: 'site-admin',
    SCANNER: 'scanner',
    CHECKER: 'checker',
    RECALLER: 'recaller',
    REMOTE_VIEWER: 'remote-viewer',
    DAMAGE_RECALLER: 'damage-recaller'
} as const;

// Roles
export const SCANNING_ROUTES_ALLOWED_ROLES = [ROLES.SCANNER] as const;
export const QA_CHECK_ROUTES_ALLOWED_ROLES = [ROLES.CHECKER] as const;
export const ALLOWED_REMOTE_VIEWER_ROLES = [ROLES.REMOTE_VIEWER] as const;

// Used to control visibility for features that are only used internally
export const INTERNAL_CUSTOMERS: readonly string[] = ['Controlant'];

/** @description Ordered by importance */
export const USER_REDIRECT_MAP = new Map<ROLE_NAME, string>([
    [ROLES.SCANNER, '/scanning'],
    [ROLES.CHECKER, '/qa-check'],
    [ROLES.SITE_ADMIN, '/scans/types'],
    [ROLES.RECALLER, '/scanning'],
    [ROLES.REMOTE_VIEWER, '/scanning'],
    [ROLES.DAMAGE_RECALLER, '/scanning']
]);

export const SCAN_TYPES_ROUTES_ALLOWED_ROLES = [ROLES.SITE_ADMIN] as const;
export const ADMIN_SETTINGS_ROUTES_ALLOWED_ROLES = [ROLES.ADMIN] as const;

// Format
export const DATE_AND_TIME_FORMAT_LONG = 'ddd, D MMM YYYY, HH:mm';
export const DATE_AND_TIME_FORMAT_SHORT = 'D MMM YYYY, HH:mm';
export const DATE_FORMAT_SHORT = 'D MMM YYYY';

// Storage key
export const USER_SETTINGS_KEY = 'userSettings';
export const ROUTE_HISTORY_KEY = 'appRoutesHistory';
